<app-language-switch></app-language-switch>

<app-eaiws-kloeber-layout *ngIf="!showFormular" [optionsInput]="options" [class.fixHeader]="fixHeader"></app-eaiws-kloeber-layout>

<div *ngIf="showFormular" class="formular">
    <app-form-kloeber [options]="options"></app-form-kloeber>
</div>